import { render, staticRenderFns } from "./Ppn_unpaid.vue?vue&type=template&id=2951e63b&scoped=true"
import script from "./Ppn_unpaid.vue?vue&type=script&lang=js"
export * from "./Ppn_unpaid.vue?vue&type=script&lang=js"
import style0 from "./Ppn_unpaid.vue?vue&type=style&index=0&id=2951e63b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2951e63b",
  null
  
)

export default component.exports